/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toDivisionProps, toDivisionRequest } from './translator/division'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchDivision, PostDivision, GetDivision, PutDivision, DeleteDivision } from '@/infrastructure/network/Monitaro/requests/division'
import { IDivisionProps } from '@/entities/Division'

export default class Division extends MonitaroGatewayBase {
  async FetchDivision(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchDivision(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.divisions.map((prop) => toDivisionProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PostDivision(params: IDivisionProps) {
    const { division } = await this.apiClient.request(new PostDivision(toDivisionRequest(params)))
    return toDivisionProps(division)
  }

  async GetDivision(id: string) {
    const { division } = await this.apiClient.request(new GetDivision(id))
    return toDivisionProps(division)
  }

  async PutDivision(id: string, params: IDivisionProps) {
    const { division } = await this.apiClient.request(new PutDivision(id, toDivisionRequest(params)))
    return toDivisionProps(division)
  }

  async DeleteDivision(id: string) {
    const { division } = await this.apiClient.request(new DeleteDivision(id))
    return toDivisionProps(division)
  }
}
